import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        user:{
            name: 'Marco'
        },
        auth:{
            token: '',
            refresh_token: '',
            expire: ''
        },
        permissions:{}
    }, 
    getters: {
        auth: (state) => {
            return state.auth;
        },
        permission: (state) => {
            return state.permissions;
        }
        // other getters
    },
    mutations: {
        setAuth: (state, newValue) => {
            
            state.auth.token = newValue.access_token;
            var time = Math.floor(Date.now() / 1000);
            if (Number.isInteger(newValue.expire_in)){
                time = time + newValue.expire_in;
            }
            state.auth.expire = time;

            state.user = {};
            state.permissions = {};
            
            state.user = newValue.user;
            console.log('prima');
            console.log(newValue.permissions);
            if (newValue.permissions != undefined){
                newValue.permissions.forEach(function(value){
                    state.permissions[value.name] = value;
                });
            }
            console.log('dopo');
            console.log(state.permissions);
            
        },
        resetAuth: (state) => {
            state.auth.token = '';
            state.auth.refresh_token = '';
            state.auth.expire = '';
            state.user = {};
            state.permissions = {};
        }
        // other mutations
    }
    
});